import { render, staticRenderFns } from "./specialPriceApplyList.vue?vue&type=template&id=572297c6&scoped=true"
import script from "./specialPriceApplyList.vue?vue&type=script&lang=js"
export * from "./specialPriceApplyList.vue?vue&type=script&lang=js"
import style0 from "./specialPriceApplyList.vue?vue&type=style&index=0&id=572297c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572297c6",
  null
  
)

export default component.exports